import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const navItems = [{
  label: 'Home',
  href: '#hero'
}, {
  label: 'The Problem',
  href: '#problem'
}, {
  label: "What's Inside",
  href: '#modules'
}, {
  label: 'Pricing',
  href: '#pricing'
}, {
  label: 'Guarantee',
  href: '#guarantee'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function FloatingNav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      // Get the fixed nav height (56px on mobile, 64px on desktop)
      const navHeight = window.innerWidth >= 768 ? 64 : 56;
      // Get element position
      const elementPosition = element.getBoundingClientRect().top;
      // Get current scroll position
      const offsetPosition = elementPosition + window.pageYOffset - navHeight;
      // Scroll to position with offset
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'}`} data-id="element-95">
        <div className="max-w-7xl mx-auto px-4" data-id="element-96">
          <div className="flex items-center justify-between h-14 md:h-16" data-id="element-97">
            {/* Logo/Brand */}
            <button onClick={() => scrollToSection('#hero')} className="font-bold text-base md:text-lg text-navy hover:text-gold transition-colors" data-id="element-98">
              Mega Music Pack
            </button>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-6 lg:gap-8" data-id="element-99">
              {navItems.map(item => <button key={item.href} onClick={() => scrollToSection(item.href)} className="text-sm font-medium text-charcoal hover:text-navy transition-colors" data-id="element-100">
                  {item.label}
                </button>)}
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 text-navy" aria-label="Toggle menu" data-id="element-101">
              {isMobileMenuOpen ? <X className="w-5 h-5" data-id="element-102" /> : <Menu className="w-5 h-5" data-id="element-103" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-104">
          {isMobileMenuOpen && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="md:hidden overflow-hidden bg-white border-t border-gray-200" data-id="element-105">
              <div className="px-4 py-3 space-y-1" data-id="element-106">
                {navItems.map(item => <button key={item.href} onClick={() => scrollToSection(item.href)} className="block w-full text-left px-3 py-2 text-sm font-medium text-charcoal hover:bg-cream hover:text-navy transition-colors rounded" data-id="element-107">
                    {item.label}
                  </button>)}
              </div>
            </motion.div>}
        </AnimatePresence>
      </motion.nav>

      {/* Spacer to prevent content from hiding under fixed nav */}
      <div className="h-14 md:h-16" data-id="element-108" />
    </>;
}